export default __webpack_public_path__ + "media/images/icon_docs-f4ae2f1097ad0f2601bf0f5b94077baf.png";